import React from 'react';
import '../styles/style.css'; 

function Footer() {
  return (
    <footer className="footer"> {/* Use the CSS class here */}
      <div>
        iAssess is your go-to platform for skill assessments, helping employees showcase their skills and Iris to find the right talent
      </div> 
    </footer>
  );
}

export default Footer;
